import { App as CapacitorApp } from '@capacitor/app';
import { LiveUpdate } from '@capawesome/capacitor-live-update';
import { Capacitor } from '@capacitor/core';


export const getNativeAppInfo = async () => {
  if (!Capacitor.isNativePlatform()) return null;

  if (Capacitor.isPluginAvailable('App')) {
    try {
      const info = await CapacitorApp.getInfo();

      if (info?.version) return { id: info.id, version: info.version, build: info.build };
    } catch (err) {
      console.warn('[AppVersion] App.getInfo() failed, falling back to LiveUpdate', err);
    }
  }

  try {
    const [{ versionName }, { versionCode }] = await Promise.all([
      LiveUpdate.getVersionName(),
      LiveUpdate.getVersionCode(),
    ]);

    return { id: null, version: versionName, build: versionCode };
  } catch (err) {
    console.warn('[AppVersion] LiveUpdate version lookup failed', err);

    return null;
  }
};

export const formatAppVersion = (info) => {
  if (!info?.version) return null;

  return info.build ? `${info.version} (${info.build})` : info.version;
};
